import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import Meta from '@bizapp-lp/workflow/organisms/Meta';
import SimpleMarketoForm, {
  SimpleMarketoFormProps,
} from '@bizapp-lp/workflow/templates/SimpleMarketoForm';

export interface DocumentClaimProps
  extends Pick<SimpleMarketoFormProps, 'marketoForm'> {
  grecaptchaKey?: string;
}

const title =
  'Workflow 資料請求 | ノーコードで現場で簡単に利用することができるワークフローサービス';
const description =
  '株式会社ワークスアプリケーションズ・エンタープライズがご提供する、Workflow 資料請求ページです。';

const DocumentClaim: React.FC<DocumentClaimProps> = (props) => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={props.grecaptchaKey}>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <SimpleMarketoForm
        header={{ from: 'workflow' }}
        heading=""
        description=""
        marketoForm={{
          ...props.marketoForm,
          formName: 'workflow_document_claim',
        }}
      />
    </GoogleReCaptchaProvider>
  );
};

export default DocumentClaim;
